var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"labels"},[(_vm.requiredLabel)?_c('span',{staticClass:"labels__required"},[_c('em',[_vm._v("*")]),_vm._v(" - "+_vm._s(_vm.$t("required_fields")))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }